var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-block',{attrs:{"title":"报价明细"}},[_c('TableWithPagination',{attrs:{"tableData":_vm.list,"row-key":"index","editConfig":{ trigger: 'munal', mode: 'cell' },"mergeCells":[{row: 0, col: 2, rowspan: 3, colspan: 0}],"columnList":_vm.columnList,"size":"mini"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }